<template>
  <div class="view-container">
    <div class="license-bar">
      <div class="license-header">
        <div class="license-title">
          <h4><i class="fas fa-id-card"></i> 授权额度</h4>
          <span class="license-tag" :class="{ warning: authorizedCount >= maxUsers * 0.85, full: authorizedCount >= maxUsers }">
            {{ authorizedCount >= maxUsers ? '已满' : authorizedCount >= maxUsers * 0.85 ? '即将满额' : '正常' }}
          </span>
        </div>
        <button @click="showBuyModal = true" class="btn btn-primary btn-sm"><i class="fas fa-cart-plus"></i> 扩容</button>
      </div>
      <div class="license-track">
        <div class="license-fill" :style="{ width: (authorizedCount / maxUsers * 100) + '%' }"></div>
      </div>
      <div class="license-detail">
        <span>已授权 <strong>{{ authorizedCount }}</strong> / <strong>{{ maxUsers }}</strong> 人</span>
        <span>{{ authorizedCount >= maxUsers ? '0' : (maxUsers - authorizedCount) }} 个剩余名额</span>
      </div>
    </div>

    <div class="search-panel">
      <div class="search-row">
        <div class="search-item"><label>用户名</label><input v-model="searchForm.userName" class="form-control" placeholder="搜索用户"></div>
        <div class="search-item"><label>部门</label><select v-model="searchForm.department" class="form-control"><option value="">全部</option><option v-for="d in departments" :key="d" :value="d">{{ d }}</option></select></div>
        <div class="search-item"><label>状态</label><select v-model="searchForm.status" class="form-control"><option value="">全部</option><option value="active">已授权</option><option value="inactive">未授权</option></select></div>
        <div class="search-actions">
          <button @click="handleSearch" class="btn btn-primary"><i class="fas fa-search"></i> 查询</button>
          <button @click="resetSearch" class="btn btn-default"><i class="fas fa-undo"></i> 重置</button>
          <button @click="openAddDialog" class="btn btn-success"><i class="fas fa-plus"></i> 新增授权</button>
        </div>
      </div>
    </div>

    <div class="table-wrapper">
      <div class="table-container">
        <table class="data-table">
          <thead><tr>
            <th width="50">ID</th><th>用户</th><th>部门</th><th width="60">版本</th><th width="90">授权时间</th><th width="90">到期时间</th>
            <th width="70">消息提醒</th><th width="60">状态</th><th width="140">操作</th>
          </tr></thead>
          <tbody>
            <tr v-for="u in paginatedData" :key="u.id">
              <td>{{ u.id }}</td>
              <td><div class="user-cell"><div class="avatar" :style="{ background: u.color }">{{ u.avatar }}</div><span class="user-name">{{ u.userName }}</span></div></td>
              <td>{{ u.department }}</td>
              <td><span class="version-tag">v{{ u.appVersion }}</span></td>
              <td class="time-cell">{{ u.authTime }}</td>
              <td class="time-cell">{{ u.expireTime }}</td>
              <td>
                <label class="toggle-switch">
                  <input type="checkbox" v-model="u.pushEnabled" @change="togglePush(u)">
                  <span class="toggle-slider"></span>
                </label>
              </td>
              <td><span class="status-badge" :class="u.status === 'active' ? 'active' : 'inactive'">{{ u.status === 'active' ? '已授权' : '已停用' }}</span></td>
              <td class="action-cell">
                <button @click="editUser(u)" class="btn btn-info btn-xs"><i class="fas fa-edit"></i></button>
                <button @click="toggleStatus(u)" class="btn btn-xs" :class="u.status==='active'?'btn-warning':'btn-success'">
                  <i :class="u.status==='active'?'fas fa-ban':'fas fa-check'"></i>
                </button>
                <button @click="deleteUser(u)" class="btn btn-danger btn-xs"><i class="fas fa-trash"></i></button>
              </td>
            </tr>
            <tr v-if="paginatedData.length===0"><td colspan="9" class="empty-cell">暂无授权用户</td></tr>
          </tbody>
        </table>
      </div>

      <div class="pagination-row">
        <div class="pagination-info">共 {{ totalCount }} 条记录</div>
        <div class="pagination-controls">
          <div class="page-size-selector"><span>每页</span><select v-model="pageSize" class="page-size-input form-control"><option :value="10">10</option><option :value="20">20</option><option :value="50">50</option></select><span>条</span></div>
          <button @click="prevPage" :disabled="currentPage===1" class="btn btn-default btn-sm pagination-btn"><i class="fas fa-chevron-left"></i></button>
          <div class="page-numbers"><button v-for="p in visiblePages" :key="p" @click="goToPage(p)" :class="['page-btn',{active:currentPage===p,disabled:p==='...'}]" :disabled="p==='...'">{{ p }}</button></div>
          <button @click="nextPage" :disabled="currentPage>=totalPages" class="btn btn-default btn-sm pagination-btn"><i class="fas fa-chevron-right"></i></button>
        </div>
      </div>
    </div>

    <div v-if="showFormModal" class="modal-overlay" @click.self="showFormModal=false">
      <div class="modal-dialog" style="width:550px">
        <div class="modal-header"><h4>{{ editingId ? '编辑授权' : '新增授权' }}</h4><button @click="showFormModal=false" class="modal-close">&times;</button></div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group"><label>用户 *</label><div class="search-select"><input v-model="form.userName" readonly class="form-control" @click="showUserPicker=true"><button @click="showUserPicker=true" class="search-btn"><i class="fas fa-search"></i></button></div></div>
            <div class="form-group"><label>部门</label><input v-model="form.department" class="form-control" readonly></div>
          </div>
          <div class="form-row">
            <div class="form-group"><label>APP版本</label><select v-model="form.appVersion" class="form-control"><option value="3.2.1">3.2.1</option><option value="3.2.0">3.2.0</option><option value="3.1.5">3.1.5</option></select></div>
            <div class="form-group"><label>到期时间</label><input v-model="form.expireTime" type="date" class="form-control"></div>
          </div>
          <div class="form-row">
            <div class="form-group"><label>消息提醒</label><label class="toggle-label"><input type="checkbox" v-model="form.pushEnabled"><span class="toggle-text">{{ form.pushEnabled ? '已开启' : '已关闭' }}</span></label></div>
            <div class="form-group"><label>状态</label><select v-model="form.status" class="form-control"><option value="active">已授权</option><option value="inactive">已停用</option></select></div>
          </div>
          <div class="form-group"><label>备注</label><textarea v-model="form.remark" class="form-control" rows="2" placeholder="备注信息"></textarea></div>
        </div>
        <div class="modal-footer"><button @click="showFormModal=false" class="btn btn-default">取消</button><button @click="saveForm" class="btn btn-primary">保存</button></div>
      </div>
    </div>

    <div v-if="showUserPicker" class="modal-overlay" @click.self="showUserPicker=false">
      <div class="modal-dialog picker-dialog">
        <div class="modal-header"><h4>选择用户</h4><button @click="showUserPicker=false" class="modal-close">&times;</button></div>
        <div class="modal-body">
          <div class="search-box"><input v-model="userSearch" class="form-control" placeholder="搜索用户..."></div>
          <div class="picker-list">
            <div v-for="u in filteredUserList" :key="u.id" class="picker-item" @click="selectUser(u)" :class="{ selected: form.userId === u.id }">
              <div class="avatar" :style="{ background: u.color }">{{ u.avatar }}</div>
              <div class="user-info"><span class="uname">{{ u.name }}</span><span class="udept">{{ u.department }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showBuyModal" class="modal-overlay" @click.self="showBuyModal=false">
      <div class="modal-dialog" style="width:450px">
        <div class="modal-header"><h4>扩容授权人数</h4><button @click="showBuyModal=false" class="modal-close">&times;</button></div>
        <div class="modal-body">
          <div class="form-group"><label>当前额度</label><div class="current-quota">{{ maxUsers }} 人</div></div>
          <div class="form-group"><label>扩容人数</label><input v-model.number="buyCount" type="number" class="form-control" placeholder="请输入扩容人数" min="10" step="10"></div>
          <div class="buy-preview" v-if="buyCount > 0">扩容后将拥有 <strong>{{ maxUsers + buyCount }}</strong> 人授权额度</div>
        </div>
        <div class="modal-footer"><button @click="showBuyModal=false" class="btn btn-default">取消</button><button @click="buyLicenses" class="btn btn-primary">确认扩容</button></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed } from 'vue'

const currentPage = ref(1); const pageSize = ref(10)
const showFormModal = ref(false); const showUserPicker = ref(false); const showBuyModal = ref(false)
const editingId = ref(null); const userSearch = ref(''); const buyCount = ref(10)
const maxUsers = ref(200)

const searchForm = reactive({ userName: '', department: '', status: '' })
const form = reactive({ userId: null, userName: '', department: '', appVersion: '3.2.1', expireTime: '', pushEnabled: true, status: 'active', remark: '' })

const departments = ref(['技术研发部','采购部','财务部','人事行政部','质量管理部','市场部'])

const users = ref([
  { id: 1, userName: '张三', avatar: '张', color: '#3b82f6', department: '技术研发部', appVersion: '3.2.1', authTime: '2026-01-15', expireTime: '2027-01-15', pushEnabled: true, status: 'active', remark: '' },
  { id: 2, userName: '李四', avatar: '李', color: '#10b981', department: '采购部', appVersion: '3.2.0', authTime: '2026-02-20', expireTime: '2027-02-20', pushEnabled: true, status: 'active', remark: '' },
  { id: 3, userName: '王五', avatar: '王', color: '#f59e0b', department: '技术研发部', appVersion: '3.2.1', authTime: '2026-03-01', expireTime: '2027-03-01', pushEnabled: false, status: 'active', remark: '' },
  { id: 4, userName: '赵六', avatar: '赵', color: '#8b5cf6', department: '采购部', appVersion: '3.1.5', authTime: '2025-06-10', expireTime: '2026-06-10', pushEnabled: true, status: 'inactive', remark: '已离职' },
  { id: 5, userName: '孙七', avatar: '孙', color: '#ef4444', department: '财务部', appVersion: '3.2.1', authTime: '2026-04-15', expireTime: '2027-04-15', pushEnabled: true, status: 'active', remark: '' },
  { id: 6, userName: '周八', avatar: '周', color: '#ec4899', department: '人事行政部', appVersion: '3.2.0', authTime: '2026-05-01', expireTime: '2027-05-01', pushEnabled: false, status: 'active', remark: '' }
])

const authorizedCount = computed(() => users.value.filter(u => u.status === 'active').length)

const allUserList = ref([
  { id: 101, name: '张三', avatar: '张', color: '#3b82f6', department: '技术研发部' },
  { id: 102, name: '李四', avatar: '李', color: '#10b981', department: '采购部' },
  { id: 103, name: '王五', avatar: '王', color: '#f59e0b', department: '技术研发部' },
  { id: 104, name: '赵六', avatar: '赵', color: '#8b5cf6', department: '采购部' },
  { id: 105, name: '孙七', avatar: '孙', color: '#ef4444', department: '财务部' },
  { id: 106, name: '周八', avatar: '周', color: '#ec4899', department: '人事行政部' },
  { id: 107, name: '吴九', avatar: '吴', color: '#06b6d4', department: '质量管理部' },
  { id: 108, name: '郑十', avatar: '郑', color: '#84cc16', department: '市场部' }
])

const filteredUserList = computed(() => !userSearch.value ? allUserList.value : allUserList.value.filter(u => u.name.includes(userSearch.value)))

const filteredData = computed(() => {
  let r = [...users.value]
  if (searchForm.userName) r = r.filter(u => u.userName.includes(searchForm.userName))
  if (searchForm.department) r = r.filter(u => u.department === searchForm.department)
  if (searchForm.status) r = r.filter(u => u.status === searchForm.status)
  return r
})
const totalCount = computed(() => filteredData.value.length)
const totalPages = computed(() => Math.ceil(totalCount.value / pageSize.value) || 1)
const paginatedData = computed(() => { const s = (currentPage.value - 1) * pageSize.value; return filteredData.value.slice(s, s + pageSize.value) })
const visiblePages = computed(() => { const ps = [], t = totalPages.value, c = currentPage.value; if (t <= 7) { for (let i = 1; i <= t; i++) ps.push(i) } else { ps.push(1); if (c > 4) ps.push('...'); for (let i = Math.max(2, c - 2); i <= Math.min(t - 1, c + 2); i++) ps.push(i); if (c < t - 3) ps.push('...'); ps.push(t) } return ps })

const handleSearch = () => { currentPage.value = 1 }
const resetSearch = () => { Object.keys(searchForm).forEach(k => searchForm[k] = ''); currentPage.value = 1 }
const prevPage = () => { if (currentPage.value > 1) currentPage.value-- }
const nextPage = () => { if (currentPage.value < totalPages.value) currentPage.value++ }
const goToPage = (p) => { if (typeof p === 'number' && p >= 1 && p <= totalPages.value) currentPage.value = p }

const openAddDialog = () => {
  if (authorizedCount.value >= maxUsers.value) { $message.warning('授权人数已满，请先扩容！'); return }
  editingId.value = null; Object.assign(form, { userId: null, userName: '', department: '', appVersion: '3.2.1', expireTime: '', pushEnabled: true, status: 'active', remark: '' }); showFormModal.value = true
}
const editUser = (u) => { editingId.value = u.id; Object.assign(form, { userId: u.id, userName: u.userName, department: u.department, appVersion: u.appVersion, expireTime: u.expireTime, pushEnabled: u.pushEnabled, status: u.status, remark: u.remark }); showFormModal.value = true }
const saveForm = () => {
  if (!form.userName) { $message.warning('请选择用户'); return }
  if (editingId.value) { const idx = users.value.findIndex(u => u.id === editingId.value); if (idx !== -1) Object.assign(users.value[idx], { ...form, id: editingId.value }) }
  else {
    if (authorizedCount.value >= maxUsers.value) { $message.success('授权人数已满！'); return }
    users.value.push({ ...form, id: Date.now(), authTime: new Date().toISOString().slice(0,10), avatar: form.userName.charAt(0), color: '#6366f1' })
  }
  showFormModal.value = false
}
const toggleStatus = (u) => {
  if (u.status === 'inactive' && authorizedCount.value >= maxUsers.value) { $message.success('授权人数已满，无法启用'); return }
  u.status = u.status === 'active' ? 'inactive' : 'active'
}
const togglePush = (u) => { $message.success('消息提醒已' + (u.pushEnabled ? '开启' : '关闭') + ': ' + u.userName) }
const deleteUser = async (u) => { if (!await $confirm('确定删除该用户授权？')) return; users.value = users.value.filter(x => x.id !== u.id) }
const selectUser = (u) => { form.userId = u.id; form.userName = u.name; form.department = u.department; showUserPicker.value = false }
const buyLicenses = () => { if (buyCount.value <= 0) { $message.warning('请输入有效数量'); return }; maxUsers.value += buyCount.value; showBuyModal.value = false; $message.success('已成功扩容至 ' + maxUsers.value + ' 人') }
</script>

<style scoped>
.view-container { padding: 20px; background: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); display: flex; flex-direction: column; max-height: calc(100vh - 110px); overflow: hidden; }

.license-bar { background: linear-gradient(135deg, #f5f3ff, #ede9fe); border: 1px solid #ddd6fe; border-radius: 8px; padding: 16px 20px; margin-bottom: 16px; flex-shrink: 0; }
.license-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
.license-title { display: flex; align-items: center; gap: 10px; }
.license-title h4 { margin: 0; font-size: 14px; color: #4c1d95; display: flex; align-items: center; gap: 6px; }
.license-tag { padding: 2px 10px; border-radius: 12px; font-size: 11px; font-weight: 500; background: #dcfce7; color: #16a34a; }
.license-tag.warning { background: #fef3c7; color: #d97706; }
.license-tag.full { background: #fee2e2; color: #dc2626; }
.license-track { height: 10px; background: #e5e7eb; border-radius: 5px; overflow: hidden; margin-bottom: 8px; }
.license-fill { height: 100%; background: linear-gradient(90deg, #8b5cf6, #6d28d9); border-radius: 5px; transition: width 0.5s ease; }
.license-detail { display: flex; justify-content: space-between; font-size: 12px; color: #6b7280; }

.search-panel { background: #f9f9f9; border: 1px solid #e7eaec; border-radius: 4px; padding: 15px; margin-bottom: 15px; flex-shrink: 0; }
.search-row { display: flex; gap: 12px; align-items: center; }
.search-item { display: flex; align-items: center; gap: 8px; }
.search-item label { font-size: 13px; color: #676a6c; font-weight: 500; white-space: nowrap; }
.search-item .form-control { padding: 6px 10px; border: 1px solid #e7eaec; border-radius: 4px; font-size: 13px; width: 160px; }
.search-actions { display: flex; gap: 10px; margin-left: auto; }

.table-wrapper { border: 1px solid #e7eaec; border-radius: 4px; overflow: hidden; display: flex; flex-direction: column; flex: 1; min-height: 0; }
.table-container { overflow-y: auto; flex: 1; }
.data-table { width: 100%; border-collapse: collapse; }
.data-table th, .data-table td { padding: 10px 12px; border-bottom: 1px solid #e7eaec; font-size: 13px; color: #676a6c; text-align: left; white-space: nowrap; }
.data-table th { background: #f5f5f5; font-weight: 600; position: sticky; top: 0; z-index: 2; }
.data-table tbody tr:hover { background: #f9fafb; }
.time-cell { color: #999; font-size: 12px; }
.user-cell { display: flex; align-items: center; gap: 8px; }
.user-cell .avatar { width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 11px; font-weight: 600; flex-shrink: 0; }
.user-name { color: #374151; font-weight: 500; }
.version-tag { background: #ede9fe; color: #7c3aed; padding: 1px 6px; border-radius: 3px; font-size: 11px; }
.status-badge { display: inline-block; padding: 2px 8px; border-radius: 3px; font-size: 11px; font-weight: 500; }
.status-badge.active { background: #dcfce7; color: #16a34a; }
.status-badge.inactive { background: #fee2e2; color: #dc2626; }
.empty-cell { text-align: center; padding: 40px; color: #999; }

.toggle-switch { position: relative; display: inline-block; width: 36px; height: 20px; }
.toggle-switch input { display: none; }
.toggle-slider { position: absolute; inset: 0; background: #d1d5db; border-radius: 20px; cursor: pointer; transition: all 0.25s; }
.toggle-slider::before { content: ''; position: absolute; top: 2px; left: 2px; width: 16px; height: 16px; border-radius: 50%; background: #fff; transition: all 0.25s; }
.toggle-switch input:checked + .toggle-slider { background: #8b5cf6; }
.toggle-switch input:checked + .toggle-slider::before { transform: translateX(16px); }

.pagination-row { display: flex; justify-content: space-between; align-items: center; padding: 12px 15px; background: #f9f9f9; border-top: 1px solid #e7eaec; flex-shrink: 0; }
.pagination-info { font-size: 13px; color: #676a6c; }
.pagination-controls { display: flex; align-items: center; gap: 10px; }
.page-numbers { display: flex; gap: 5px; }
.page-btn { width: 32px; height: 32px; border: 1px solid #e7eaec; background: #fff; color: #676a6c; border-radius: 4px; cursor: pointer; font-size: 13px; display: flex; align-items: center; justify-content: center; }
.page-btn:hover:not(.disabled) { border-color: #8b5cf6; color: #8b5cf6; }
.page-btn.active { background: #8b5cf6; border-color: #8b5cf6; color: #fff; }
.page-btn.disabled { cursor: not-allowed; opacity: 0.5; }
.pagination-btn { width: 32px; height: 32px; padding: 0; display: flex; align-items: center; justify-content: center; }
.page-size-selector { display: flex; align-items: center; gap: 5px; font-size: 13px; }
.page-size-input { width: 70px; padding: 4px 8px; }

.action-cell .btn-xs { margin: 0 2px; padding: 4px 8px; font-size: 11px; border-radius: 4px; cursor: pointer; border: 1px solid transparent; }
.btn-info.btn-xs { background: #3498db; color: #fff; }
.btn-warning.btn-xs { background: #f39c12; color: #fff; }
.btn-danger.btn-xs { background: #e74c3c; color: #fff; }
.btn-success.btn-xs { background: #27ae60; color: #fff; }

.toggle-label { display: flex; align-items: center; gap: 10px; cursor: pointer; font-size: 13px; color: #374151; padding: 8px 0; }
.toggle-text { color: #6b7280; }

.modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal-dialog { background: #fff; border-radius: 8px; max-height: 85vh; overflow-y: auto; }
.picker-dialog { width: 420px; }
.modal-header { display: flex; justify-content: space-between; align-items: center; padding: 15px 20px; border-bottom: 1px solid #e7eaec; }
.modal-header h4 { margin: 0; font-size: 16px; }
.modal-close { background: none; border: none; font-size: 24px; cursor: pointer; color: #999; }
.modal-close:hover { color: #333; }
.modal-body { padding: 20px; }
.modal-footer { padding: 12px 20px; border-top: 1px solid #e7eaec; display: flex; justify-content: flex-end; gap: 10px; }
.form-row { display: flex; gap: 15px; margin-bottom: 15px; }
.form-group { flex: 1; }
.form-group label { display: block; font-size: 13px; color: #676a6c; margin-bottom: 5px; font-weight: 500; }
.form-group .form-control { width: 100%; padding: 8px 12px; border: 1px solid #e7eaec; border-radius: 4px; font-size: 13px; box-sizing: border-box; }
.form-group textarea.form-control { resize: vertical; }
.search-select { display: flex; gap: 6px; }
.search-select .form-control { flex: 1; cursor: pointer; }
.search-btn { padding: 6px 10px; border: 1px solid #e7eaec; border-radius: 4px; background: #f9f9f9; cursor: pointer; color: #676a6c; }
.search-btn:hover { background: #e7eaec; }
.search-box { margin-bottom: 12px; }
.picker-list { max-height: 300px; overflow-y: auto; }
.picker-item { display: flex; align-items: center; gap: 10px; padding: 10px 12px; border-bottom: 1px solid #f0f0f0; cursor: pointer; font-size: 13px; }
.picker-item:hover { background: #f9fafb; }
.picker-item.selected { background: #f5f3ff; }
.picker-item .avatar { width: 34px; height: 34px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 12px; font-weight: 600; flex-shrink: 0; }
.user-info { flex: 1; }
.uname { display: block; color: #1f2937; font-weight: 500; }
.udept { font-size: 11px; color: #9ca3af; }

.current-quota { font-size: 20px; font-weight: 700; color: #8b5cf6; padding: 8px 0; }
.buy-preview { margin-top: 12px; padding: 10px; background: #f0f9ff; border-radius: 4px; font-size: 13px; color: #374151; }

.btn { padding: 6px 14px; border: 1px solid transparent; border-radius: 4px; font-size: 13px; cursor: pointer; display: inline-flex; align-items: center; gap: 4px; transition: all 0.2s; }
.btn-primary { background: #8b5cf6; color: #fff; border-color: #8b5cf6; }
.btn-primary:hover { background: #7c3aed; }
.btn-default { background: #fff; color: #374151; border-color: #d1d5db; }
.btn-default:hover { background: #f9fafb; }
.btn-success { background: #6366f1; color: #fff; border-color: #6366f1; }
.btn-success:hover { background: #4f46e5; }
.btn-sm { padding: 5px 10px; font-size: 12px; }
</style>
